import { styled } from 'styled-components';
import { detailsRichText } from '@/styles/richText';

export const ScBonusShopTermsText = styled.div`
  ${detailsRichText}
`;
